import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { bgtDashboardCountersFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import { getObjectByKey } from "../../../../shared/utils/utils";
import CounterWidget from "../../../../shared/components/widget/counterWidget/CounterWidget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import classes from "./BgtCountersWidget.module.css";

const BgtCountersWidget = ({ topContent }) => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const bgt = getObjectByKey("bgt", platforms);
    const counterEntities = useSelector((state) => selectEntitiesByFilters(state, bgtDashboardCountersFilters));

    return (
        <CounterWidget
            color="#19086F"
            titleColor="#FFF"
            title={texts.bgt}
            icon={iconsList.bgt}
            mainLink={bgt?.link}
            counters={counterEntities}
            className={classes.BgtCountersWidget}
            topContent={topContent}
        />
    );
};

export default BgtCountersWidget;
